export * from './morador-averbacao';